/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { SummaryRequestBuilderRequestsMetadata, type SummaryRequestBuilder } from './summary/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/invoices
 */
export interface InvoicesRequestBuilder extends BaseRequestBuilder<InvoicesRequestBuilder> {
    /**
     * The summary property
     */
    get summary(): SummaryRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const InvoicesRequestBuilderUriTemplate = "{+baseurl}/api/analytics/invoices";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const InvoicesRequestBuilderNavigationMetadata: Record<Exclude<keyof InvoicesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    summary: {
        requestsMetadata: SummaryRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
